import { OlxAdvertActionPayload, OlxLocation } from '../modules/crm/power-olx-v2/interfaces/power-olx-v2.interface';

export enum AI_TASK_TYPE {
  CHAT_REPLY = 'CHAT_REPLY',
  CORRECT_TEXT = 'CORRECT_TEXT',
  ADVERT_DESCRIPTION = 'ADVERT_DESCRIPTION',
  SITE_GENERATE = 'SITE_GENERATE',
  SITE_EDIT_BLOCK = 'SITE_EDIT_BLOCK',
  SITE_IMAGE = 'SITE_IMAGE',
}

export type SiteImageSize = '1024x1024' | '1536x1024' | '1024x1536';

export interface GenerateAIResponseBodyXData {
  text?: string;
  chat_id?: string;
  automation_id?: string;
  /** SITE_GENERATE: site name. */
  name?: string;
  /** SITE_EDIT_BLOCK: HTML of the selected block. */
  html?: string;
  /** SITE_EDIT_BLOCK: CSS rules applied to the selected block. */
  css?: string;
  /** SITE_IMAGE: image size. */
  size?: SiteImageSize;
}

export interface GenerateAIResponseBody {
  task: AI_TASK_TYPE;
  x_data?: GenerateAIResponseBodyXData;
}

export interface GenerateAdvertDescriptionPayload {
  channel_id: string;
  advert: OlxAdvertActionPayload;
  location?: OlxLocation;
  category_path_text?: string;
}
